<pre [innerHtml]="pretty(jsonData)"></pre>
